import { useAccountSelector } from '@wajeez-web/stores/account';

export const useAssignPromoCodeToUtilityUser = () => {
  return useAccountSelector(({ sales }) => sales.assignPromoCodeToUtilityUser);
};

export const useAssignPublisherToUtilityUser = () => {
  return useAccountSelector(({ sales }) => sales.assignPublisherToUtilityUser);
};

export const useGetUtilityPromoCodeAnalysis = () => {
  return useAccountSelector(({ sales }) => sales.getUtilityPromoCodeAnalysis);
};
